<template>
  <div
    :class="
      navigation || culturePop
        ? 'popup'
        : '' || startProjectPop || recruitPop
        ? 'popup black'
        : '' || awardsPop
        ? 'black-gra'
        : ''
    "
    class="container viewPage trueEtnView"
  >
    <header-area />

    <div class="worksView topPosition" :class="readyAction ? 'ready-action' : ''">
      <div class="contsBox">
        <div class="viewInCon">
          <div class="workTopTitle">
            <div class="workSlogan web">
              Take your <span>first</span> step <br />to making an invest in ETN!
            </div>
            <div class="workSlogan mobile">
              Take your <span>first</span> step to making an invest in ETN!
            </div>
            <div class="workTopDay">
              <p>한국투자증권 TRUE ETN 웹사이트 개편</p>
              <ul>
                <li>PC / Mobile web</li>
                <li>2021.11.12</li>
              </ul>
            </div>
            <div class="workTopSns">
              <a href="https://www.trueetn.com" target="_blank" class="siteAddr"
                >https://www.trueetn.com</a
              >
              <ul>
                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/trueEtn"
                    title="새로운 투자 트렌드, ETN 투자의 첫걸음"
                    hashtags="플립커뮤니케이션즈,한국투자증권"
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="facebook">
                      <a href="javascript:;" class="wFacebook">
                        <img src="@/assets/images/@sns_fb_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/trueEtn"
                    title="새로운 투자 트렌드, ETN 투자의 첫걸음"
                    hashtags="플립커뮤니케이션즈,한국투자증권"
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="twitter">
                      <a href="javascript:;" class="wTweeter">
                        <img src="@/assets/images/@sns_tw_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <a href="javascript:;" @click.prevent="doCopy" class="wChain">
                    <img src="@/assets/images/@web_link_w.png" alt="" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="workVisual">
        <div class="workImg">
          <span class="workMoveTxt">
            <marquee-text :duration="15"
              >&nbsp;Take your first step to making an invest in ETN!&nbsp;</marquee-text
            >
          </span>
          <img class="web" src="@/assets/images/works_view/trueEtn/trueEtn_visual.png" alt="" />
          <img
            class="mobile"
            src="@/assets/images/works_view/trueEtn/trueEtn_visual_m.jpg"
            alt=""
          />
        </div>
      </div>

      <div class="contsBox">
        <div class="topInfo">
          국내 상장지수증권(ETN) 시장은 2021년 9월, 지수가치 총액 8조 원을 돌파하며 새로운 투자
          트렌드로 자리 잡았습니다. 빠르게 성장하는 시장의 흐름을 따라 많은 증권사에서 ETN 상품을
          연이어 상장하고 있습니다. 이에 한국투자증권은 ETN 상품에 특화된 전용 홈페이지인 ‘TRUE ETN’
          웹사이트를 전면 개편하며 기존 고객의 편의성 향상은 물론 신규 투자자 유치 확대와 관리자의
          운영 편의성 제고를 노렸습니다.
        </div>
      </div>
    </div>

    <kinesis-container event="scroll">
      <div class="wideConts">
        <div class="trueConcept">
          <div
            class="arrowInfo"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="arrowBox">
              <div class="roundBox roundOne">
                <div class="roundTxt">
                  <p class="roundTit">신규 고객</p>
                  ETN 상품의 개념 이해부터<br />
                  구매까지 돕는 투자 도우미
                </div>
              </div>
              <div class="roundBox roundTwo">
                <div class="roundTxt">
                  <p class="roundTit">기존 고객</p>
                  양질의 정보 습득과<br />
                  사용이 쉬운 홈페이지
                </div>
              </div>
              <div class="roundBox roundThree">
                <div class="roundTxt">
                  <p class="roundTit">관리자</p>
                  편리한 운영과<br />
                  활용적인 홍보 채널
                </div>
              </div>
              <div class="arrowImg">
                <img
                  class="web"
                  src="@/assets/images/works_view/trueEtn/needs-up.png"
                  alt="NEEDS UP Easy and convenient"
                />
                <img
                  class="mobile"
                  src="@/assets/images/works_view/trueEtn/needs-up_m.png"
                  alt="NEEDS UP Easy and convenient"
                />
              </div>
            </div>
            <div class="roundBg one"></div>
            <div class="roundBg two"></div>
          </div>
        </div>

        <div class="trueConcept type1">
          <div class="mainPageview">
            <div class="workView">
              <div class="txtWrap">
                <div class="tit">MAIN</div>
                <div class="txt">
                  노후화된 기존 홈페이지를 모바일 환경에서의 접근이<br class="mobile" />
                  용이한 반응형 웹으로 개편하고,<br class="web" />ETN 투자의 개념 이해부터<br
                    class="mobile"
                  />
                  상품 선택까지 한 번에 이루어질 수 있도록<br class="mobile" />
                  홈페이지의 활용도를 높였습니다.
                </div>
              </div>
              <div
                class="imgBox"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <div class="imgFront">
                  <img src="@/assets/images/works_view/trueEtn/img_main.png" alt="" />
                </div>
                <div class="imgPhoneoutter">
                  <div>
                    <img src="@/assets/images/works_view/trueEtn/img_main_mobile.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="trueConcept type2">
          <div class="bgWave1"></div>
          <div class="bgWave2"></div>
          <div class="worksView">
            <div class="txtWrap">
              <div class="smallTit">신규 가입자도 어려움없이</div>
              <div class="tit">쉽게 찾는 TRUE ETN 상품</div>
            </div>

            <div
              class="pointSharp1"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="pointWrap">
                <div class="truePoint">
                  <span>Point #1</span>
                </div>
                <div class="trueTit">Menu</div>
                <div class="titUnder">ETN 상품에만 집중한 정보 제공</div>
                <div class="trueDesc">
                  새로워진 TRUE ETN은 불필요한 메뉴를 과감히 삭제하고 ETN<br class="mobile" />
                  상품에만 집중했습니다.<br class="web" />
                  투자 과정에 따라 원하는 정보를 얻을 수 <br class="mobile" />있도록 간결하지만
                  핵심적인 메뉴를 배치했습니다.<br />
                  <span class="line1">상품의 개념을 설명</span>하고
                  <span class="line2">가이드를 제시</span>해 더욱 쉽게
                  <br class="mobile" />
                  <span class="line3">상품을 이해하고 구매</span>로 이어질 수 있도록 유도했습니다.
                </div>
                <div class="roundWrap">
                  <div class="roundBox round1"></div>
                  <div class="roundBox round2"></div>
                  <div class="roundBox round3"></div>
                  <div class="roundBox round4"></div>
                  <ul class="order">
                    <li>ETN 상품</li>
                    <li>ETN 교육</li>
                    <li><span class="web">투자가이드</span><span class="mobile">고객센터</span></li>
                    <li><span class="web">고객센터</span><span class="mobile">투자가이드</span></li>
                  </ul>
                </div>
              </div>
              <div class="imgBox">
                <div class="imgPhoneoutter">
                  <div>
                    <img src="@/assets/images/works_view/trueEtn/img_menu.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="pointSharp2">
            <div class="pointWrap">
              <div class="truePoint">
                <span>Point #2</span>
              </div>
              <div class="trueTit">Exploration</div>
              <div class="titUnder">한눈에 확인하고 바로 비교하기</div>
              <div class="trueDesc">
                40여 개의 ETN 상품을 주제별로 모아<br />
                한 번에 확인할 수 있는 한눈에 펼쳐보기를 신설했습니다.
              </div>
            </div>
            <div
              class="explorImgbox"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="background">
                <div class="wordAni word1">
                  <img src="@/assets/images/works_view/trueEtn/exp01.png" alt="아시아" />
                </div>
                <div class="wordAni word2">
                  <img src="@/assets/images/works_view/trueEtn/exp02.png" alt="탄소" />
                </div>
                <div class="wordAni word3">
                  <img src="@/assets/images/works_view/trueEtn/exp03.png" alt="미국" />
                </div>
                <div class="wordAni word4">
                  <img src="@/assets/images/works_view/trueEtn/exp04.png" alt="구리" />
                </div>
                <div class="wordAni word5">
                  <img src="@/assets/images/works_view/trueEtn/exp05.png" alt="에너지" />
                </div>
                <div class="wordAni word6">
                  <img src="@/assets/images/works_view/trueEtn/exp06.png" alt="금속" />
                </div>
                <div class="wordAni word7">
                  <img src="@/assets/images/works_view/trueEtn/exp07.png" alt="인버스" />
                </div>
              </div>
              <div class="imgBox">
                <img src="@/assets/images/works_view/trueEtn/img_exploration.png" alt="" />
              </div>
            </div>

            <div
              class="explorImgbox2"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="pointWrap">
                <div class="trueDesc">
                  또한 상품 비교를 통해 원하는 상품들의 조건을<br />
                  비교할 수 있어 고객의 상품 선택을 도왔습니다.
                </div>
              </div>
              <div class="imgBox2">
                <img src="@/assets/images/works_view/trueEtn/img_exploration2.png" alt="" />
              </div>
            </div>
          </div>

          <div class="pointSharp3">
            <div class="pointWrap">
              <div class="truePoint">
                <span>Point #3</span>
              </div>
              <div class="trueTit">Contents</div>
              <div class="titUnder">ETN 상품 이해를 돕는 정보 구성</div>
              <div class="trueDesc web">
                각 상품의 요약과 중요한 데이터 수치는 상단에 노출해 빠르게 정보를 파악할 수
                있으며,<br />
                상품명에 버튼을 적용해 다른 상품으로 간편하게 이동할 수 있어 다양한 정보를 얻을 수
                있습니다.<br />
                또한 상세 내용을 데이터 시각화해 투자자가 정보를 직관적이고 쉽게 파악할 수 있도록
                구성했습니다.
              </div>
              <div class="trueDesc mobile">
                각 상품의 요약과 중요한 데이터 수치는<br class="mobile" />상단에 노출해 빠르게
                정보를 파악할 수 있으며,<br class="mobile" />
                상품명에 버튼을 적용해 다른 상품으로 간편하게<br class="mobile" />
                이동할 수 있어 다양한 정보를 얻을 수 있습니다.<br class="mobile" />
                또한 상세 내용을 데이터 시각화해 투자자가 정보를<br class="mobile" />
                직관적이고 쉽게 파악할 수 있도록 구성했습니다.
              </div>
            </div>

            <div
              class="homepageRoliing"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="rollingArea">
                <div>
                  <img src="@/assets/images/works_view/trueEtn/img_trun_rolling.jpg" alt="" />
                </div>
              </div>
            </div>

            <div
              class="imgBox"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="imgPhoneoutter leftType">
                <img src="@/assets/images/works_view/trueEtn/img_content_1.png" alt="" />
              </div>
              <div class="imgPhoneoutter rightType">
                <img src="@/assets/images/works_view/trueEtn/img_content_2.png" alt="" />
                <span class="ir"
                  ><img src="@/assets/images/works_view/trueEtn/img_content_2_1.png" alt=""
                /></span>
              </div>
            </div>
          </div>
        </div>

        <div class="trueConcept type3">
          <div class="waveTop">
            <div class="bgWave3"></div>
            <div class="bgWave4"></div>
          </div>
          <div class="worksView">
            <div class="txtWrap">
              <div class="smallTit">고객도 관리자도 모두</div>
              <div class="tit">이용이 편리한 TRUE ETN</div>
            </div>
          </div>

          <div
            class="pointSharp4"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="pointWrap">
              <div class="truePoint">
                <span>Point #1</span>
              </div>
              <div class="trueTit">Menu</div>
              <div class="titUnder">자유로운 메뉴 및 내용 간 이동</div>
              <div class="trueDesc">
                메뉴와 탭에 셀렉박스를 추가해 원하는<br class="web" />
                메뉴 및 내용으로 자유롭게<br class="mobile" />
                이동할 수 있어<br class="web" />
                페이지 이탈을 줄였습니다.
              </div>
            </div>
            <div class="imgBox">
              <div class="imgPhoneoutter">
                <div>
                  <img src="@/assets/images/works_view/trueEtn/img_menu2.png" alt="" />
                </div>
              </div>
            </div>
          </div>

          <div class="pointSharp5">
            <div class="pointWrap">
              <div class="truePoint">
                <span>Point #2</span>
              </div>
              <div class="trueTit">Search</div>
              <div class="titUnder">빠르고 쉬운 검색</div>
              <div class="trueDesc web">
                관심 주제의 상품을 폭넓고 빠르게 찾을 수 있는 검색 환경은 투자에 있어 매우 중요한
                요소입니다.<br />
                통합검색 기능을 추가해 상품 정보와 함께 공지사항, 공시정보, 뉴스/시황, FAQ까지<br />
                한 화면에서 다양한 정보를 얻을 수 있도록 개선했습니다.
              </div>
              <div class="trueDesc mobile">
                관심 주제의 상품을 폭넓고 빠르게 찾을 수 있는<br class="mobile" />
                검색 환경은 투자에 있어 매우 중요한 요소입니다.<br class="mobile" />
                통합검색 기능을 추가해 상품 정보와 함께 공지사항,<br class="mobile" />
                공시정보, 뉴스/시황, FAQ까지 한 화면에서<br class="mobile" />
                다양한 정보를 얻을 수 있도록 개선했습니다.
              </div>
            </div>

            <div
              class="searchConcept"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="searchBox">
                <div class="wordGroup">
                  <span class="word type1">코</span>
                  <span class="word type2">스</span>
                  <span class="word type3">피</span>
                  <span class="wordBar"></span>
                </div>
                <div class="searchResult">
                  <img src="@/assets/images/works_view/trueEtn/img_search_txt.jpg" alt="" />
                </div>
              </div>
              <div class="searchRound">
                <p class="title">SEARCH MODE</p>
                <span class="type1">ETN 상품</span>
                <span class="type2">FAQ</span>
                <span class="type3">공지사항</span>
                <span class="type4">공시정보</span>
                <span class="type5">뉴스/시황</span>
              </div>
            </div>
          </div>

          <div
            class="pointSharp6"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="inner">
              <div class="pointWrap">
                <div class="truePoint">
                  <span>Point #3</span>
                </div>
                <div class="trueTit">ADMIN</div>
                <div class="titUnder">편리한 정보 제공, 양질의 정보 습득</div>
                <div class="trueDesc">
                  기존 수기로 등록하던 정보를 데이터 연동 방식으로 개선하고, <br />
                  공지사항은 카테고리별로 구분해 일괄 업로드할 수 있어 관리자의 <br />
                  편의성을 높이는 동시에 고객에게도 양질의 정보를 제공합니다.
                </div>
              </div>
              <div class="imgBox">
                <div class="imgPhoneoutter">
                  <div>
                    <img src="@/assets/images/works_view/trueEtn/img_admin1.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div class="imgBox type2">
              <div class="imgPhoneoutter">
                <div>
                  <img src="@/assets/images/works_view/trueEtn/img_admin2.png" alt="" />
                </div>
              </div>
            </div>
          </div>

          <div
            class="pointSharp7"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="pointWrap">
              <div class="truePoint">
                <span>Point #4</span>
              </div>
              <div class="trueTit">CALCULATOR</div>
              <div class="titUnder">TRUE ETN 수익률 계산기</div>
              <div class="trueDesc">
                ETN 투자에 대한 개념을 이해하고 상품을 확인한 후에 모의 투자를 할<br
                  class="mobile"
                />
                수 있는 수익률 계산기를 제공합니다. <br />
                선택한 기간 내에 운용되는 상품만 연동되어 보다 정확한 수치를 제공<br
                  class="mobile"
                />하며 투자 선택에 직접적인 도움이 될 수 있습니다.
                <br class="web" />
                또한 TRUE ETN<br class="mobile" />
                종목 매출 상승을 위한 마케팅 요소로도 활용할 수 있습니다.
              </div>
            </div>
            <div class="sec1Slider swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <img src="@/assets/images/works_view/trueEtn/slide_1.png" alt="" />
                </div>
                <div class="swiper-slide">
                  <img src="@/assets/images/works_view/trueEtn/slide_2.png" alt="" />
                </div>
                <div class="swiper-slide">
                  <img src="@/assets/images/works_view/trueEtn/slide_3.png" alt="" />
                </div>
                <div class="swiper-slide">
                  <img src="@/assets/images/works_view/trueEtn/slide_4.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </kinesis-container>

    <div class="worksView">
      <div class="contsBox">
        <div class="backToList">
          <router-link :to="{ name: 'works' }" class="backBtn">
            <img src="@/assets/images/@ico_back_x2.jpg" alt="" />
            <span>Back to list</span>
          </router-link>
        </div>
      </div>

      <router-link v-if="true" :to="{ name: 'works-KBstar' }" class="longEnd vType">
        <div class="viewType">
          <span>next</span>
          <strong class="web">KB스타뱅킹 앱 리뉴얼</strong>
          <strong class="mobile">KB스타뱅킹 <br />앱 리뉴얼</strong>
        </div>

        <div class="engBg KBstarEndBg">
          <span />
        </div>
      </router-link>
    </div>

    <footer-area />
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import Lottie from "vue-lottie";
import HeaderArea from "@/components/Header";
import FooterArea from "@/components/Footer";
import common from "@/shared/mixin/common.js";
import MarqueeText from "vue-marquee-text-component";
import VueKinesis from "vue-kinesis";
import { TweenLite } from "gsap/all";
import kiwoombg01 from "@/assets/json/motion/kiwoombg01.json";
import kiwoombg02 from "@/assets/json/motion/kiwoombg02.json";
Vue.use(VueKinesis);

export default {
  mixins: [common],
  name: "Main",
  /* head: {
      title: {
        inner: "한국투자증권 TURE ETN"
      }
    }, */
  head: {
    title: function() {
      return {
        inner: this.meta.title
      };
    },
    meta: function() {
      return [
        {
          name: "description",
          content: this.meta.desc
        },
        {
          name: "keywords",
          content: this.meta.keywords
        },
        // Open Graph
        { property: "og:title", content: this.meta.title },
        { property: "og:description", content: this.meta.desc },
        { property: "og:type", content: "website" },
        { property: "og:url", content: this.meta.url },
        { property: "og:image", content: this.meta.img },

        // Additional OG tags
        { property: "og:site_name", content: this.meta.siteName }
      ];
    }
  },
  components: {
    HeaderArea,
    FooterArea,
    MarqueeText,
    Lottie
  },
  data() {
    return {
      meta: {
        siteName: "한국투자증권 TRUE ETN 홈페이지 | 플립커뮤니케이션즈",
        title: "한국투자증권 TRUE ETN 홈페이지",
        desc:
          "한국투자증권은 ETN 전용 사이트 TRUE ETN을 모바일 환경에 최적화된 반응형 웹으로 전면 개편하여 ETN 투자의 전 과정을 지원합니다. 주제별 ETN 상품 한눈에 확인, 상품간 비교, 투자 정보 제공 등 고객 편의성을 높였습니다. 관리자도 데이터 연동으로 운영 효율화를 실현했습니다.",
        keywords:
          "한국투자증권, TRUE ETN, ETN, 상장지수증권, 웹사이트, 개편, 투자 트렌드, 증권사, 홈페이지, 모바일 환경, 반응형 웹, 투자 개념, 상품 선택, 정보 제공, 검색 환경",
        url: "https://www.pulip.com/works/TrueEtn",
        img: "https://www.pulip.com/pulip-logo.jpg"
      },
      W: 0,
      icoInter: null,
      icoVal: 0
    };
  },
  computed: {
    ...mapState("common", {
      readyAction: state => state.readyAction,
      startProjectPop: state => state.startProjectPop,
      recruitPop: state => state.recruitPop,
      awardsPop: state => state.awardsPop,
      culturePop: state => state.culturePop,
      navigation: state => state.navigation
    }),
    W2() {
      return this.W / 2;
    },
    W3() {
      return this.W / 3;
    },
    W4() {
      return this.W / 4;
    }
  },
  methods: {
    // vuejs Bicint
    doCopy() {
      this.$copyText("https://www.pulip.com/sns/trueEtn").then(
        function(e) {
          alert("복사되었습니다.");
          console.log(e);
        },
        function(e) {
          console.log(e);
        }
      );
    },
    handleResize() {
      this.W = window.innerWidth;
      this.H = window.innerHeight;
    },
    visibilityChanged(isVisible, entry) {
      // this.isVisible = isVisible
      console.log(entry);
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    this.sec1Slider1.destroy();
    window.removeEventListener("resize", this.handleResize);
    clearInterval(this.icoInter);
  },
  mounted() {
    this.sec1Slider1 = new window.Swiper(".sec1Slider.swiper-container", {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      slidesPerView: "auto",
      centeredSlides: true,
      loop: true,
      spaceBetween: 30,
      speed: 1000,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false
      },
      breakpoints: {
        751: {
          spaceBetween: 130
        }
      }
    });
  }
};
</script>
